import { Organization } from './Organization'

const typeName = 'Supplier'

class Supplier extends Organization {
  constructor(ob: any) {
    super({ ...ob, type: ob.type || typeName })
  }
}

export { Supplier }
